import { nothing as A } from '../lit-html.js';

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const l=l=>null!=l?l:A;

export { l as ifDefined };
//# sourceMappingURL=if-defined.js.map
